import printNotice from "@/pages/reportCenter/reportCenter";

import layout from "@/components/layout/layout";
const reportCenter = {
  path: "/reportCenter",
  component: layout,
  meta: { roles: ["shop", 'r4gys'], title: "报表中心", icon: "icon-baobiaobiaoweiguanli" },
  children: [
    {
      path: "/notice/exportReport",
      component: printNotice,
      name: "reportCenter",
      meta: { roles: ["shop", 'r4gys'], title: "导出报表" }
    }
  ]
};
export default reportCenter;



// WEBPACK FOOTER //
// ./src/router/modules/reportCenter.js